'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = require('../../../DateUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageTimestamp = function (_React$Component) {
    (0, _inherits3.default)(MessageTimestamp, _React$Component);

    function MessageTimestamp() {
        (0, _classCallCheck3.default)(this, MessageTimestamp);
        return (0, _possibleConstructorReturn3.default)(this, (MessageTimestamp.__proto__ || (0, _getPrototypeOf2.default)(MessageTimestamp)).apply(this, arguments));
    }

    (0, _createClass3.default)(MessageTimestamp, [{
        key: 'render',
        value: function render() {
            var date = new Date(this.props.ts);
            var suffix = this.props.suffix;
            return _react2.default.createElement(
                'span',
                { className: 'mx_MessageTimestamp', title: (0, _DateUtils.formatFullDate)(date, this.props.showTwelveHour), 'aria-hidden': true },
                (0, _DateUtils.formatTime)(date, this.props.showTwelveHour),
                suffix && suffix
            );
        }
    }]);
    return MessageTimestamp;
}(_react2.default.Component); /*
                              Copyright 2015, 2016 OpenMarket Ltd
                              Copyright 2018 Michael Telatynski <7t3chguy@gmail.com>
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

MessageTimestamp.propTypes = {
    ts: _propTypes2.default.number.isRequired,
    showTwelveHour: _propTypes2.default.bool,
    suffix: _propTypes2.default.node
};
exports.default = MessageTimestamp;
module.exports = exports['default'];
//# sourceMappingURL=MessageTimestamp.js.map